/** 構造形式 */
export const CONSTRUCTION_METHOD = {
  WOOD: {
    UNSELECTED: '-1',
    WOODEN: '01',
    WALL: '02',
    PREFAB: '03',
    OTHER: '09'
  },
  STEEL: {
    UNSELECTED: '-1',
    RAMEN: '11',
    BRACE: '12',
    PREFAB: '13',
    OTHER: '19'
  },
  RC: {
    UNSELECTED: '-1',
    REINFORCED: '21',
    PRECAST: '22',
    BLOCK: '23',
    STEEL_REINFORCED: '24',
    MIXED: '28'
  }
} as const
